import React from "react";
import { useTranslation } from "react-i18next";
import { LuigisboxHitItem } from "./luigisboxAutocompleteTypes";

interface LuigisboxAutocompleteRelatedBlockProperties {
    readonly relatedQueries: LuigisboxHitItem<"query">[];
    readonly onAnchorClick: (url: string) => void;
}

export default function LuigisboxAutocompleteRelatedBlock({ relatedQueries, onAnchorClick }: LuigisboxAutocompleteRelatedBlockProperties): React.JSX.Element | undefined {
    const { t } = useTranslation("header");

    const relatedQueriesList: React.JSX.Element[] = relatedQueries.map((query) => (
        <a
            href={query.url}
            className="autocomplete-trending-link"
            key={query.attributes.title}
            onClick={(event): void => {
                event.preventDefault();
                onAnchorClick(`/vyhledavani?q=${encodeURIComponent(query.url)}`);
            }}
        >
            <span dangerouslySetInnerHTML={{ __html: query.attributes.title }}></span>
        </a>
    ));

    if (relatedQueries.length === 0) {
        return undefined;
    }

    return (
        <div>
            <div className="autocomplete-section">
                <span>{t("relatedSearchQueries")}</span>
            </div>
            <div className="autocomplete-results autocomplete-results-trending">
                {relatedQueriesList}
            </div>
        </div>
    );
}
